import { useMutation } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";

interface VerifyPayload {
  code: string;
}

interface VerifyResponse {
  status: string;
  data?: {
    isActive: boolean;
  };
  message?: string;
}

interface UseVerifySuccessorSectionCodeOpts {
  onSuccess?: (data: VerifyResponse) => void;
  onError?: (error: unknown) => void;
}

export function useVerifySuccessorSectionCode(options?: UseVerifySuccessorSectionCodeOpts) {
  return useMutation({
    mutationKey: ["verify-successor-section-code"],
    mutationFn: async ({ code }: VerifyPayload) => {
      const res = await axiosInstance.post<VerifyResponse>(
        "/successor/verify-section-code",
        { code }
      );
      return res.data;
    },
    onMutate: () => {
      Toast({
        id: "verifySuccessorSectionCode",
        message: "Weryfikacja kodu...",
        type: TOAST_TYPES_ENUM.LOADING,
      });
    },
    onSuccess: (data) => {
      Toast({
        id: "verifySuccessorSectionCode",
        message: "Kod poprawny. Dostęp aktywowany.",
        type: TOAST_TYPES_ENUM.SUCCESS,
      });
      options?.onSuccess?.(data);
    },
    onError: (err: any) => {
      Toast({
        id: "verifySuccessorSectionCode",
        message: err?.response?.data?.message || "Błąd weryfikacji kodu",
        type: TOAST_TYPES_ENUM.ERROR,
      });
      options?.onError?.(err);
    },
    retry: false,
  });
}
